import layoutHelpers from '@/layout/helpers.js'
import { konuAdiGetir } from '@/utils/konularSelectList'

export default function () {
  return {
    // Public url
    publicUrl: process.env.BASE_URL,
    // Layout helpers
    layoutHelpers,

    get baseDomainMi () {
      return window.location.host === 'kuranogren.com' || window.location.host === 'www.kuranogren.com' ||
          window.origin.indexOf('localhost') !== -1
    },

    get tugvaMi () {
      return window.location.host === 'tugva.kuranogren.com'
    },

    get sakaryaMi () {
      return window.location.host === 'sakarya.kuranogren.com'
    },

    get hususiMi () {
      return window.location.host === 'hususi.kuranogren.com'
    },
    get karabukMu () {
      return window.location.host === 'krbkunv.kuranogren.com'
    },
    get ilimYaymaMi () {
      return window.location.host === 'ilimyayma.kuranogren.com'
    },

    get ankaraAkPartiIlMi () {
      return window.location.host === 'ankaraakpartiil.kuranogren.com'
    },

    get ziraatKatilimMi () {
      return window.location.host === 'ziraatkatilim.kuranogren.com'
    },

    get siracMi () {
      return window.location.host === 'sirac.kuranogren.com'
    },

    konuAdi (kur, gun) {
      return konuAdiGetir(kur, gun)
    },

    getProfilGuncellemeGozukecekMi () {
      return this.baseDomainMi
    },

    get datetimeConfig () {
      return {
        enableTime: true,
        altInput: true,
        allowInput: true,
        minuteIncrement: 10,
        time_24hr: true,
        dateFormat: 'Z',
        altFormat: 'd-m-y H:i'
      }
    },

    get datetimeConfigForHususiRegister () {
      return {
        enableTime: true,
        altInput: true,
        allowInput: false,
        minuteIncrement: 60,
        ignoreReadonly: true,
        time_24hr: true,
        dateFormat: 'Z',
        altFormat: 'd-m-y H:i',
        minTime: '11:00',
        maxTime: '17:00',
        minDate: new Date(2021, 5, 14),
        maxDate: new Date(2021, 5, 20)
      }
    },

    get dateConfig () {
      return {
        altInput: true,
        allowInput: true,
        dateFormat: 'Z',
        altFormat: 'd-m-Y'
      }
    },

    get link () {
      return window.location.origin
    },
    get aktifDonem () {
      if (this.baseDomainMi) {
        return 13
      } else if (this.tugvaMi) {
        return 2
      }
      return 0
    },

    // Check for RTL layout
    get isRtlMode () {
      return document.documentElement.getAttribute('dir') === 'rtl' ||
                document.body.getAttribute('dir') === 'rtl'
    },

    // Check if IE
    get isIEMode () {
      return typeof document.documentMode === 'number'
    },

    // Check if IE10
    get isIE10Mode () {
      return this.isIEMode && document.documentMode === 10
    },

    // Layout navbar color
    get layoutNavbarBg () {
      return 'navbar-theme'
    },

    // Layout sidenav color
    get layoutSidenavBg () {
      return 'sidenav-theme'
    },

    // Layout footer color
    get layoutFooterBg () {
      return 'footer-theme'
    },

    // Animate scrollTop
    scrollTop (to, duration, element = document.scrollingElement || document.documentElement) {
      if (element.scrollTop === to) return
      const start = element.scrollTop
      const change = to - start
      const startDate = +new Date()

      // t = current time; b = start value; c = change in value; d = duration
      const easeInOutQuad = (t, b, c, d) => {
        t /= d / 2
        if (t < 1) return c / 2 * t * t + b
        t--
        return -c / 2 * (t * (t - 2) - 1) + b
      }

      const animateScroll = () => {
        const currentDate = +new Date()
        const currentTime = currentDate - startDate
        element.scrollTop = parseInt(easeInOutQuad(currentTime, start, change, duration))
        if (currentTime < duration) {
          requestAnimationFrame(animateScroll)
        } else {
          element.scrollTop = to
        }
      }

      animateScroll()
    }
  }
}
